<form class="report-filters" [formGroup]="form">
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="startDate" [placeholder]="'Start Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="endDate" [placeholder]="'End Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="status" [showClear]="true" [options]="policyStatuses"
                placeholder="Policy status"></p-dropdown>
        </span>
    </div>
    <div class="controls-wrapper" *ngIf="canFilterByUser">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="user" [showClear]="true" [options]="users"
                placeholder="Choose user"></p-dropdown>
        </span>
    </div>
    <div class="controls-wrapper button-wrapper">
        <p-button label="Search" [text]="true" [raised]="true" severity="success" [disabled]="form.invalid"
            (onClick)="submit()" class="report-action-button" icon="pi pi-search"></p-button>
        <p-button label="Export" [text]="true" [raised]="true" (onClick)="export()"
            severity="success" class="report-action-button" icon="pi pi-download"></p-button>
    </div>
</form>
<hr />
<div class="table-container">
    <p-table #reportTable [value]="reports" [scrollable]="true"
        scrollHeight="400px" styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }"
        responsiveLayout="stack" [breakpoint]="'768px'">
        <ng-template pTemplate="header">
            <tr>
                <th>Date</th>
                <th>Insured Name</th>
                <th>Customer Mobile Number</th>
                <th>Product</th>
                <th>Occupation</th>
                <th>Nature Of Employment</th>
                <th>Employer Name</th>
                <th>Employer Type</th>
                <th>Inception Date</th>
                <th>End Date</th>
                <th>Policy Number</th>
                <th>Currency</th>
                <th>Currency Code</th>
                <th>Net Monthly Salary</th>
                <th>Monthly Max Benefit Limit</th>
                <th>Months Paid</th>
                <th>Monthly Premium</th>
                <th>Stamp Duty</th>
                <th>Payment Provider</th>
                <th>Policy Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
            <tr>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Date</span>
                    {{ report["dateCreated"] ? (report["dateCreated"] | date : "dd/MM/yyyy") : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Insured Name</span>
                    {{ report.customer ? report.customer.firstName + " " + report.customer.lastName : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Customer Mobile Number</span>
                    {{ report["customer"] ? report["customer"]["mobileNumber"]["countryCode"] + report["customer"]["mobileNumber"]["phoneNumber"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Product</span>
                    {{ report.product ? report.product : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Occupation</span>
                    {{ report.occupation ? report.occupation : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Nature Of Employment</span>
                    {{ report.natureOfEmployment ? report.natureOfEmployment : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Employer Name</span>
                    {{ report.employerName ? report.employerName : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Employer Type</span>
                    {{ report.employerType ? report.employerType : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Inception Date</span>
                    {{ report.startDateTime ? (report.startDateTime | date : "short") : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">End Date</span>
                    {{ report.endDateTime ? (report.endDateTime | date : "short") : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Policy Number</span>
                    {{ report.number ? report.number : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Currency</span>
                    {{ report.currency ? report.currency.name : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Currency Code</span>
                    {{ report.currency.name ? report.currency.name : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Net Monthly Salary</span>
                    {{ report.netMonthlySalary ? report.netMonthlySalary : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Monthly Max Benefit Limit</span>
                    {{ report.monthlyPremium ? (report.monthlyPremium | currency) : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Months Paid</span>
                    {{ report.stampDuty ? (report.stampDuty | currency) : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Monthly Premium</span>
                    {{ report.monthlyPremium }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Stamp Duty</span>
                    {{ report.stampDuty ? (report.stampDuty | currency) : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Payment Provider</span>
                    {{ report.paymentProvider }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Policy Status</span>
                    {{ report.status }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
